import {
    ADDNEWWITHDRAWLIMIT_SUCCESS,
    ADDNEWWITHDRAWLIMIT_FAILED,
    RESET_ADDNEWWITHDRAWLIMIT,
    LOADING_ADDNEWWITHDRAWLIMIT,
    NETWORK_ERROR_ADDNEWWITHDRAWLIMIT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddNewWithdrawLimit = () => {
    return { type: RESET_ADDNEWWITHDRAWLIMIT };
};

const addNewWithdrawLimit = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDNEWWITHDRAWLIMIT });
    await partnerServices
        .post("addWithDrawLimit", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addNewWithdrawLimitsuccess(res.data));
                    break;
                default:
                    dispatch(addNewWithdrawLimitFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADDNEWWITHDRAWLIMIT, payload: err });
        });
};
function addNewWithdrawLimitsuccess(data) {
    return {
        type: ADDNEWWITHDRAWLIMIT_SUCCESS,
        payload: data,
    };
}
function addNewWithdrawLimitFailed(data) {
    return {
        type: ADDNEWWITHDRAWLIMIT_FAILED,
        payload: data,
    };
}

export { resetAddNewWithdrawLimit, addNewWithdrawLimit };
